import React from 'react';
import './PrintJobStatusDialog.css';

const itemLabel = (item) =>
  item?.label || item?.route?.label || item?.profile || item?.profileKey || 'Print group';

export default function PrintJobStatusDialog({
  status,
  busy = false,
  onClose,
  onConfirmOutput,
  onRetryUnconfirmed,
  onBrowserFallback,
}) {
  if (!status) return null;
  const uncertain = status.uncertain || [];
  const pending = status.pending || [];
  const submitted = status.submitted || [];
  const hasRisk = uncertain.length > 0 || pending.length > 0;
  return (
    <div className="print-job-status-overlay" role="presentation">
      <section className="print-job-status-dialog" role="alertdialog" aria-modal="true">
        <p className="print-job-status-dialog__eyebrow">London Smoke &amp; Cure</p>
        <h2>{hasRisk ? 'Check output before continuing' : 'Print job submitted'}</h2>
        {status.benchLine ? (
          <p className="print-job-status-dialog__bench" role="status">
            {status.benchLine}
          </p>
        ) : null}
        <p>{status.message}</p>
        {submitted.length > 0 && (
          <div className="print-job-status-dialog__group is-submitted">
            <b>Submitted before the issue</b>
            <span>{submitted.map(itemLabel).join(' · ')}</span>
          </div>
        )}
        {uncertain.length > 0 && (
          <div className="print-job-status-dialog__group is-warning">
            <b>Outcome uncertain</b>
            <span>{uncertain.map(itemLabel).join(' · ')}</span>
          </div>
        )}
        {pending.length > 0 && (
          <div className="print-job-status-dialog__group">
            <b>Not attempted</b>
            <span>{pending.map(itemLabel).join(' · ')}</span>
          </div>
        )}
        {hasRisk && (
          <p className="print-job-status-dialog__warning">
            Do not repeat the complete job. Check the printer first, then choose only
            the unconfirmed output you need.
          </p>
        )}
        <footer>
          <button type="button" className="toolkit-btn toolkit-btn--ghost" onClick={onClose} disabled={busy}>
            Close
          </button>
          {hasRisk && onBrowserFallback && (
            <button type="button" className="toolkit-btn toolkit-btn--secondary" onClick={onBrowserFallback} disabled={busy}>
              Browser print unconfirmed
            </button>
          )}
          {hasRisk && onRetryUnconfirmed && (
            <button type="button" className="toolkit-btn toolkit-btn--secondary" onClick={onRetryUnconfirmed} disabled={busy}>
              Retry unconfirmed with QZ
            </button>
          )}
          {!hasRisk && onConfirmOutput && (
            <button type="button" className="toolkit-btn toolkit-btn--primary" onClick={onConfirmOutput} disabled={busy}>
              Output checked and correct
            </button>
          )}
        </footer>
      </section>
    </div>
  );
}
